import { render, staticRenderFns } from "./ExpressCreationResume.vue?vue&type=template&id=633b3207&"
import script from "./ExpressCreationResume.vue?vue&type=script&lang=js&"
export * from "./ExpressCreationResume.vue?vue&type=script&lang=js&"
import style0 from "./ExpressCreationResume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports